import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession({ forceRefresh: false });
    const token = session.tokens?.idToken?.toString();
    if (token) {
      config.headers['authorization'] = token;
    }
  } catch (e) {
    console.warn('トークン取得失敗:', e);
  }
  return config;
});

export default api;
